<script setup lang="ts" xmlns="http://www.w3.org/1999/html">
import {onMounted, ref, toRef} from "vue";
import {useCartStore} from "@/stores/cartStore";
import SelectDropdown from "@/components/SelectDropdown.vue";
const properties = defineProps(['lineItem']);

const cartStore = useCartStore();
const lineItem = toRef(properties, 'lineItem');
const giftType = ref('');
const giftFirstName = ref('');
const giftLastName = ref('');
const senderName = ref('');
const giftMessage = ref('');

onMounted(() => {
  giftType.value = lineItem.value.properties?._gift_type || '1';
  giftFirstName.value = lineItem.value.properties?._gift_first_name || '';
  giftLastName.value = lineItem.value.properties?._gift_last_name || '';
  senderName.value = lineItem.value.properties?.From || '';
  giftMessage.value = lineItem.value.properties?.Message || '';
});

cartStore.$subscribe((_, state) => {
  let changes = false;
  const address = state.localLineItems[lineItem.value.key].selectedAddress;

  if(!giftFirstName.value && !giftLastName.value && address) {
    changes = true;
    giftFirstName.value = address.first_name;
    giftLastName.value = address.last_name;
  }

  if(changes) {
    cartStore.saveGiftMessage({
      key: lineItem.value.key,
      _gift_type: giftType.value,
      _gift_first_name: giftFirstName.value,
      _gift_last_name: giftLastName.value,
      _gift_sender: senderName.value,
      Message: giftMessage.value
    });
  }
});

const handleSave = () => {
  cartStore.saveGiftMessage({
    key: lineItem.value.key,
    _gift_type: giftType.value,
    _gift_first_name: giftFirstName.value,
    _gift_last_name: giftLastName.value,
    _gift_sender: senderName.value,
    Message: giftMessage.value,
  });
}

</script>
<template>
  <div class="product-gift-data product-gift">
    <div class="row">
      <div class="col col--wide">
        <SelectDropdown
          :options="[
            {
              value: '1',
              label: 'Myself',
              removable: false
            },
            {
              value: '2',
              label: 'Other Recipient',
              removable: false
            }
          ]"
          :model-value="giftType"
          placeholder="Recipient"
          @update:modelValue="$event => {
            giftType = $event;
            handleSave();
          }"
        />
      </div>
    </div>
    <div class="row" v-if="giftType === '2'">
      <div class="col">
        <div class="label">First Name <span class="form__label-error">* Enter recipient name</span></div>
        <input type="text" aria-label="First Name" autocomplete="off" v-model="giftFirstName" placeholder="First Name" @input="handleSave">
        <ul class="autocomplete-recipients"></ul>
      </div>
      <div class="col">
        <div class="label">Last Name <span class="form__label-error">* Enter your name</span></div>
        <input type="text" autocomplete="off" aria-label="Last Name" v-model="giftLastName" placeholder="Last Name" @input="handleSave">
      </div>
    </div>
    <div class="row">
      <div class="col col--wide">
        <div class="label">From (optional)</div>
        <input type="text" autocomplete="off" aria-label="From" v-model="senderName" placeholder="From" @input="handleSave">
      </div>
    </div>
    <div class="row">
      <div class="col col--wide">
        <div class="label">Enter Your Gift Message</div>
        <textarea aria-label="Add a message" class="" maxlength="250" placeholder="Add a message" cols="30" rows="10" v-model="giftMessage" @input="handleSave"></textarea>
        <div class="product-gift-data__count">{{giftMessage.length}}/250 Characters</div>
      </div>
    </div>
  </div>
</template>